const centsToDollars = (cents = "") => {
  if (!cents) return "N/A"
  else return (parseFloat(cents) / 100).toFixed(2)
}

export default centsToDollars
